import React from 'react';

import { createUltimatePagination, ITEM_TYPES } from 'react-ultimate-pagination';
//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

const flatButtonStyle = {
  minWidth: 0,
  paddingRight: 12,
  paddingLeft: 12,
  fontWeight: 'normal',
};

const activePage = {
  color: '#f26045',
  backgroundColor: '#fafafa',
};

const Page = ({ value, isActive, onClick, isDisabled }) => (
  <Button
    style={isActive ? { ...flatButtonStyle, ...activePage } : flatButtonStyle}
    label={value.toString()}
    onClick={onClick}
    disabled={isDisabled || isActive}
  >
    {value.toString()}
  </Button>
);

const Ellipsis = ({ onClick, isDisabled }) => (
  <Button style={flatButtonStyle} label="..." onClick={onClick} disabled={true}>
    {'...'}
  </Button>
);

const FirstPageLink = ({ isActive, onClick, isDisabled, value }) => (
  <Button style={flatButtonStyle} onClick={onClick} disabled={isDisabled || isActive}>
    {'<<'}
  </Button>
);

const PreviousPageLink = ({ isActive, onClick, isDisabled }) => (
  <Button style={flatButtonStyle} onClick={onClick} disabled={isDisabled || isActive}>
    {'<'}
  </Button>
);

const NextPageLink = ({ isActive, onClick, isDisabled }) => (
  <Button style={flatButtonStyle} onClick={onClick} disabled={isDisabled || isActive}>
    {'>'}
  </Button>
);

const LastPageLink = ({ isActive, onClick, isDisabled }) => (
  <Button style={flatButtonStyle} onClick={onClick} disabled={isDisabled || isActive}>
    {'>>'}
  </Button>
);

const itemTypeToComponent = {
  [ITEM_TYPES.PAGE]: Page,
  [ITEM_TYPES.ELLIPSIS]: Ellipsis,
  [ITEM_TYPES.FIRST_PAGE_LINK]: FirstPageLink,
  [ITEM_TYPES.PREVIOUS_PAGE_LINK]: PreviousPageLink,
  [ITEM_TYPES.NEXT_PAGE_LINK]: NextPageLink,
  [ITEM_TYPES.LAST_PAGE_LINK]: LastPageLink,
};

const UltimatePaginationMUI = createUltimatePagination({ itemTypeToComponent });

export default UltimatePaginationMUI;
